import { inject } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { cameraActions } from "../camera/camera.actions";
import { Store } from "@ngrx/store";
import { worldActions } from "./world.actions";
import { switchMap, combineLatest, filter, map, withLatestFrom } from "rxjs";
import { Vector3 } from "three/src/math/Vector3.js";
import { EventsWebsocketService } from "../../services/entities/events-websocket.service";
import { entityActions } from "../entities/entity.actions";
import { generateUUID } from "three/src/math/MathUtils.js";
import { CollisionType, Components, EntityType } from "../entities/entity.model";
import { LookingAtProperties } from "../entities/component-properties-dto/looking-at.properties.dto";
import { selectUserAvatarId } from "../auth/auth.selector";
import {networkActions} from "../network/network.actions";

const actionsRequiredForBinstToBeReady = [
  worldActions.pixiRendererReady,
  worldActions.threeRendererReady,
  worldActions.surfacesReady,
];

let readyActions = [];

export const triggerBinstReady = createEffect(
  (
      actions$ = inject(Actions),
      store = inject(Store),
      websocketService = inject(EventsWebsocketService),
  ) => {
    return actions$.pipe(
      ofType(...actionsRequiredForBinstToBeReady),
      map((action) => {
        console.log(JSON.stringify(action));
        if (!(action.type in readyActions)) {
          readyActions.push(action.type);
        }
        if (readyActions.length === actionsRequiredForBinstToBeReady.length) {
          console.log("Binst ready");
          store.dispatch(worldActions.binstViewReady({ viewId: "main" }));
        }
      }),
    );
  },
  { functional: true, dispatch: false },
);

let tickTimer: any;
let tickCount = 0;
export const startTicks = createEffect(
  (
  actions$ = inject(Actions),
  store = inject(Store),
  websocketService = inject(EventsWebsocketService)
  ) => {
    return actions$.pipe(
      ofType(worldActions.binstViewReady),
      map((action) => {
        // tickTimer = setInterval(() => {
        //   tick(store);
        // }, 1000);
      }),
    );
  },
  { functional: true, dispatch: false },
);

function tick(store) {
  tickCount += 1;
  if (tickCount % 10 === 0) {
    store.dispatch(worldActions.timerTicked10s({ currentTick: tickCount }));
  }
    if (tickCount % 3 === 0) {
        store.dispatch(worldActions.timerTicked3s({ currentTick: tickCount }));
    }
}
